import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "grid-content text-xl font-bold" }, "Mapping product", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_MappingVariant = _resolveComponent("MappingVariant")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _mergeProps(_ctx.content, {
    backPageTitle: "Back",
    class: "hide-croll"
  }), {
    default: _withCtx(() => [
      (_ctx.state.isLoading)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            gutter: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_skeleton, {
                    rows: 12,
                    animated: true
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_el_row, {
            key: 1,
            gutter: 24,
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                gutter: 24,
                class: "mb-3"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 24,
                class: "mb-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_MappingVariant, {
                    product: _ctx.state.product,
                    catalogs: _ctx.state.catalogs
                  }, null, 8, ["product", "catalogs"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 16))
}